import { styled } from '@mui/system';
import { pxToRem } from '../../../../utils/getFontValue';

export const ProfileImgWrapper = styled('div')(({ theme }) => ({
  width: pxToRem(158),
  height: pxToRem(158),
  borderRadius: pxToRem(32),
  overflow: 'hidden',
}));
